export default "__VITE_ASSET__COoBELuj__"